<!-- OrderDetailBody.vue -->
<template>
    <div>
        <div class="common-header-wrap">
            <mt-header :title="$t('menu.order_detail')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div
                class="order-body"
                v-if="order_info"
        >
            <div class="order_state">
                <i class="iconfont" v-if="order_info.o2o_errand_order_state == '40'">&#xe61b;</i>
                <i class="iconfont" v-else>&#xe61a;</i>
                <span>{{ $t(`order.errand_send_state[${order_info.o2o_errand_order_state}]`) }}</span>
            </div>

            <div class="address">
                <div>
                    <span>{{ order_info.o2o_errand_order_pickup_name }}</span>
                    <span class="mobile" v-if="order_info.o2o_errand_order_pickup_phone">{{ order_info.o2o_errand_order_pickup_phone }}</span>
                </div>
                <p>
                    {{ $t('address.sender_address') }}：{{ order_info.o2o_errand_order_pickup_address }}
                </p>
            </div>
            <div class="address">
                <div>
                    <span>{{ order_info.o2o_errand_order_deliver_name }}</span>
                    <span class="mobile" v-if="order_info.o2o_errand_order_deliver_phone">{{ order_info.o2o_errand_order_deliver_phone }}</span>
                </div>
                <p>
                    {{ $t('address.receiver_address') }}：{{ order_info.o2o_errand_order_deliver_address }}
                </p>
            </div>
            <div class="address" v-if="order_info.o2o_distributor_id">
                <div>
                    <span>{{ order_info.o2o_distributor_realname }}</span>
                    <span class="mobile">{{ order_info.o2o_distributor_phone }}</span>
                </div>
                <p>
                    {{ $t('order_detail.distributor_info') }}
                </p>
            </div>
            <div class="detail">
                <div class="number">
                    <p>
                        {{ $t('order_detail.goods_info')}}: {{ order_info.o2o_errand_order_detail }}
                    </p>
                    <p>
                        {{ $t('order_detail.goods_weight') }}: {{ order_info.o2o_errand_order_weight }}{{ $t('general.weight_unit') }}
                    </p>
                    <p>
                        {{ $t('order_detail.goods_value') }}: {{ $t('order_detail.goods_value_under', [utils.currencyPrice(order_info.o2o_errand_order_goods_price)]) }}
                    </p>
                </div>
            </div>

            <div class="detail" v-if="order_info.o2o_errand_order_if_pay_on_behalf">
                <div class="number">
                    <p>{{ $t('order_detail.pay_on_behalf_amount') }}: {{ order_info.o2o_errand_order_pay_on_behalf_amount }} {{ $t('general.dollar') }}</p>
                </div>
            </div>

            <div class="detail">
                <div class="number">
                    <label
                    >{{ $t('order_detail.order_number') }}: {{ order_info.o2o_errand_order_sn }}
                    </label>
                    <p>
                        {{ $t('order_detail.order_time') }}: {{$moment.unix(order_info.o2o_errand_order_add_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                    <p v-if="order_info.o2o_errand_order_appointment_time">
                        {{ $t('order_detail.appointment_time') }}: {{$moment.unix(order_info.o2o_errand_order_appointment_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                    <p v-if="order_info.o2o_errand_order_payment_time">
                        {{ $t('order_detail.pay_time') }}: {{$moment.unix(order_info.o2o_errand_order_payment_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                    <p v-if="order_info.o2o_errand_order_pickup_time">
                        {{ $t('order_detail.pickup_time') }}: {{$moment.unix(order_info.o2o_errand_order_pickup_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                    <p v-if="order_info.o2o_errand_order_finish_time">
                        {{ $t('order_detail.finish_time') }}: {{$moment.unix(order_info.o2o_errand_order_finish_time).format('YYYY-MM-DD HH:mm')}}
                    </p>
                </div>

            </div>

            <div class="detail" v-if="order_info.o2o_errand_order_remark!=''">
                <div class="number">
                    <p>
                        {{ $t('order.note') }}: {{ order_info.o2o_errand_order_remark }}
                    </p>

                </div>
            </div>

            <div class="detail" style="position: relative;">
                <mt-button size="small" type='primary' @click="openChatroom()">{{ $t('chatroom.chat_with_admin') }}</mt-button>
                <mt-badge
                    v-if="unreadMessageCount > 0"
                    size="large"
                    type="error"
                    class="order-count"
                    style="position: absolute; top: -0.7rem; right: 0rem;">
                    {{ unreadMessageCount }}
                </mt-badge>
            </div>

            <div
                    class="desc section-header section-footer"
            >
                <div class="container">
                    <label class="title">{{ $t('order_detail.distance_price') }}</label>
                    <label class="subtitle">{{ $t('general.dollar_sign') }}{{ utils.currencyPrice(order_info.o2o_errand_order_distance_price) }}</label>
                </div>
                <div class="container" v-if="order_info.o2o_errand_order_weight_price!=0">
                    <label class="title">{{ $t('order_detail.weight_price') }}</label>
                    <label class="subtitle">{{ $t('general.dollar_sign') }}{{ utils.currencyPrice(order_info.o2o_errand_order_weight_price) }}</label>
                </div>
                <div class="container" v-if="order_info.o2o_errand_order_time_price!=0">
                    <label class="title">{{ $t('order_detail.time_price') }}</label>
                    <label class="subtitle">{{ $t('general.dollar_sign') }}{{ utils.currencyPrice(order_info.o2o_errand_order_time_price) }}</label>
                </div>
                <div class="container" v-if="order_info.o2o_errand_order_gratuity!=0">
                    <label class="title">{{ $t('order_detail.gratuity') }}</label>
                    <label class="subtitle">{{ $t('general.dollar_sign') }}{{ utils.currencyPrice(order_info.o2o_errand_order_gratuity) }}</label>
                </div>
                <label class="amount"
                >{{ $t('order_detail.total_price') }}：<span> {{ $t('general.dollar_sign') }}{{ utils.currencyPrice(order_info.o2o_errand_order_amount) }}</span>
                </label>
            </div>

        </div>

		<!-- Chatroom, connect to custom service -->
		<mt-popup
			v-model="chatroomVisible"
			:closeOnClickModal="false"
			position="right"
			popup-transition="popup-fade"
			class="common-popup-wrapper">
				<div class="common-header-wrap">
					<mt-header :title="$t('chatroom.chat_with_admin')" class="common-header">
						<mt-button slot="left" icon="back" @click="chatroomVisible=false"></mt-button>
					</mt-header>
				</div>
				<div class="common-popup-content" style='top: 4rem'>
					<Chatroom
						:visible="chatroomVisible"
						:params="chatroomParams"
						:toClientName="toClientName"
						:toClientAvatar="toClientAvatar"
						:fromPopup="true"
					></Chatroom>
				</div>
		</mt-popup>
	</div>
</template>

<script>

import { Toast } from 'mint-ui'
import { getErrandOrderInfo } from '../../../api/memberO2oErrand'
import Chatroom from '@/components/progress_dialog/util/Chatroom'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
	name: 'MemberO2oErrandOrderDetail',
	components: {
		Chatroom
	},
	data () {
		return {
			order_info: {},
			chatroomVisible: false,
			roomId: undefined
		}
	},
	created: function () {
		if (this.$route.query.o2o_errand_order_id) {
			getErrandOrderInfo(this.$route.query.o2o_errand_order_id).then(res => {
				this.order_info = res.result.o2o_errand_order_info
			}).catch(function (error) {
				Toast(error.message)
			})
		}
	},
	watch: {
		chatroomParams: {
			immediate: true,
			deep: true,
			handler: function (val) {
				this.$socket.emit('getRoomIdByOrder', val, (res) => {
					if (res.code === 0) {
						this.roomId = res.results.roomId
					}
				})
			}
		}
	},
	computed: {
		...mapState({
			'rooms': (state) => state.chatroom.rooms
		}),
		...mapGetters(['getUnreadCount', 'memberInfo']),
		toClientName: function () {
			return this.$t('chatroom.client_name_alias_admin')
		},
		toClientAvatar: function () {
			return require('../../../assets/image/custom-service-avatar.png')
		},
		unreadMessageCount: function () {
			return this.getUnreadCount(this.roomId, this.chatroomParams.toClientType)
		},
		chatroomParams: function () {
			return {
				role: 'member',
				name: this.memberInfo.member_name,
				orderSn: this.order_info.o2o_errand_order_sn,												
				orderId: Number(this.$route.query.o2o_errand_order_id),
				orderType: 'send',
				toClientType: 'admin'
			}
		}
	},

	methods: {
		...mapActions([
			'joinMultipleRooms'
		]),
		openChatroom() {
			this.joinMultipleRooms({
				clients: ['admin'],
				order: this.order_info
			})
			this.chatroomVisible = true
		}
	}
}
</script>
<style lang="scss" scoped>
    .order-body {
        overflow: auto;
        height: 100%;
        position: absolute;
        width: 100%;
        padding-bottom: $footerHeightFull;
        margin-top: -2rem;
        .desc{
            line-height: 1rem;
            .container {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                background-color: #fff;
            }
            .title {
                width: 5rem;
                font-size: 0.7rem;
                color: #4e545d;
                margin-left: 0.6rem;
            }
            .subtitle {
                flex: 1;
                margin-left: 1rem;
                margin-right: 0.6rem;
                color: $primaryColor;
                font-size: 0.7rem;
                text-align: right;
            }
        }

    }
    .order_state {
        background:#fa800a;
        height: 3.5rem;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        padding-bottom: 10px;
        i {
            color:#fff;
            font-size:1.2rem;
            padding: 0 0.5rem;
        }
        span {
            font-size: 0.8rem;
            color: #fff;
        }
    }
    .containers {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        border-bottom: 1px solid #e8eaed;
    }
    .photo {
        width: 4rem;
        height: 4rem;
        margin: 0.75rem 0.5rem 0.75rem 0.75rem;
        border: 1px solid #e8eaed;
        flex-basis: 4rem;
        flex-shrink: 0;
    }
    .right-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 0 0.75rem 0 0;
        width: 100%;
        overflow: hidden;
    }
    .title {
        color: #4e545d;
        font-size: 0.7rem;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .property {
        font-size: 0.65rem;
        color: #999999;
        padding-top: 0.5rem;
    }
    .count {
        margin-top: 0.2rem;
        color: #999999;
        font-size: 0.65rem;
        margin-right: 0.5rem;
    }
    .desc-wrapper {
        height: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 1rem;
    }
    .price {
        color: $primaryColor;
        font-size: 0.8rem;
        margin-left: 0;
    }
    .count {
        color: #999999;
        font-size: 0.8rem;
        margin-left: 0.5rem;
    }
    .address {
        height: 4.4rem;
        background-color: #fff;
        margin-bottom: 0.5rem;
        div {
            padding: 0.55rem 0.5rem 0;
        }
        img {
            height: 0.8rem;
        }
        span {
            color: #4e545d;
            font-size: 0.8rem;
            &.mobile {
                padding-left: 1rem;
            }
        }
        p {
            margin: 0.25rem 0.9rem 0.55rem 0.5rem;
            font-size: 0.7rem;
            color: #999999;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

    .contact {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 2.3rem;
        background-color: #fff;
        margin-top: 0.4rem;
        border-bottom: 1px solid #e8eaed;
        padding: 0 0.65rem;
        span {
            font-size: 0.6rem;
            color: #4e545d;
            padding-right: 0.3rem;
        }
        img {
            width: 0.6rem;
            height: 0.65rem;
        }
    }

    .detail {
        display: flex;
        flex-direction: column;
        font-size: 0.7rem;
        color: #999999;
        background-color: #fff;
        margin: 0.4rem 0;
        box-sizing: border-box;
        .number {
            padding: 0.7rem 0.8rem;
            border-bottom: 1px solid #e8eaed;
            p {
                padding-top: 0.3rem;
                font-size: 0.7rem;
            }
            button {
                color: #999999;
                height: 1rem;
                background-color: #fff;
                border: 1px solid #999999;
                width: 2.7rem;
                height: 1rem;
                border-radius: 0.1rem;
                font-size: 0.7rem;
            }
        }
        .pay {
            border-bottom: 1px solid #e8eaed;
            padding: 0.7rem 0.8rem;
        }
        .givetime {
            padding: 0.7rem 0.8rem;
            font-size: 0.7rem;
        }
        input {
            background-color: #fff;
            border: 1px solid #999999;
        }
    }
    .desc {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding-top: 0.6rem;
        box-sizing: border-box;
        margin-bottom: 4rem;
        .desc-item {
            flex: 1;
            margin-top: 0.5rem;
        }
        .amount {
            display: flex;
            justify-content: flex-end;
            font-size: 0.7rem;
            color: #4e545d;
            padding-right: 0.75rem;
            border-top: 1px solid #e8eaed;
            margin-top: 0.6rem;
            height: 2.25rem;
            line-height: 2.25rem;
            span {
                font-size: 0.8rem;
                color: $primaryColor;
            }
        }
    }
    .ship {
        margin-bottom: 0;
    }
</style>

<!-- 字体图标样式覆盖 -->
<style>
    .mint-toast-icon {
        font-size: 1.9rem;
    }
    button {
        padding: 0;
    }
</style>
